import type { SessionData } from '#auth';
import { isSignUpRequired } from './extract-requirements';
import { isAgentSnapStripeVerificationIncomplete, isSenderMoovSignupIncomplete } from './is-verification-in-progress';

export function shouldRedirectToSignUp(auth: SessionData | null): boolean {
  if (!auth) {
    return false;
  }

  return (
    isSignUpRequired(auth.requirements) ||
    !auth.approved ||
    isSenderMoovSignupIncomplete(auth) ||
    isAgentSnapStripeVerificationIncomplete(auth)
  );
}
